import { useContext, useEffect, useState } from "react";

import Grid from "@anwb/poncho/components/grid";

import { FiltersContext } from "../../contexts/FiltersContext";
import FilterQueryBuilder from "../../helpers/FilterQueryBuilder";
import { useAuthorizedRequest } from "../../helpers/api";
import { FilterConfiguration, FilterKeyword, FilterType } from "../../types/filters";
import { School } from "../../types/school";
import Filters from "../Filters/Filters";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

import SchoolTable from "./Tables/SchoolTable/SchoolTable";

const filtersForCurrentView: FilterConfiguration[] = [
  {
    type: FilterType.OptionalBoolean,
    keyword: FilterKeyword.IsOpenOnBasispoort,
    label: "Open on Basispoort",
  },
  {
    type: FilterType.OptionalBoolean,
    keyword: FilterKeyword.HasActiefOrders,
    label: "Has Actief Orders",
  },
];

function Schools() {
  const [schools, setSchools] = useState<School[]>([]);
  const { filters } = useContext(FiltersContext);

  const { isLoading, setRequest } = useAuthorizedRequest<School[]>();

  useEffect(() => {
    setRequest({
      path: `/schools${new FilterQueryBuilder(
        filters,
        filtersForCurrentView,
      ).getUrlSearchParamString()}`,
      onSuccess: (data) => {
        setSchools(data);
      },
    });
  }, [setRequest, filters]);

  return (
    <Grid columns={1}>
      <Grid.Item>
        <Filters filterConfigurations={filtersForCurrentView} />
      </Grid.Item>
      <Grid.Item>{isLoading ? <LoadingSpinner /> : <SchoolTable schools={schools} />}</Grid.Item>
    </Grid>
  );
}

export default Schools;
